import { useState, useEffect } from 'react';

const ShippingRates = ({ country, onShippingSelect, selectedRate }) => {
  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log('Country in ShippingRates:', country);
    
    if (!country) return;
    
    setLoading(true);
    
    // Get shipping rates based on country
    const getRatesByCountry = (countryName) => {
      console.log('Getting rates for country:', countryName);
      
      switch(countryName) {
        case 'Canada':
          console.log('Returning CA rates');
          return [
            {
              service: 'Canada Post Expedited',
              rate: 20.00,
              estimated_days: '2-5',
              code: 'canadapost_expedited'
            },
            {
              service: 'Canada Post Xpresspost',
              rate: 23.00,
              estimated_days: '1-3',
              code: 'canadapost_xpresspost'
            },
            {
              service: 'Canada Post Priority',
              rate: 60.00,
              estimated_days: '1-2',
              code: 'canadapost_priority'
            }
          ];
        case 'United States':
          console.log('Returning US rates');
          return [
            {
              service: 'Small Packet',
              rate: 13.00,
              estimated_days: '5-8',
              code: 'us_small_packet'
            },
            {
              service: 'Tracked Packet',
              rate: 20.00,
              estimated_days: '4-7',
              code: 'us_tracked_packet'
            },
            {
              service: 'Expedited Parcel',
              rate: 26.00,
              estimated_days: '3-5',
              code: 'us_expedited'
            },
            {
              service: 'X-Press Post',
              rate: 36.00,
              estimated_days: '2-4',
              code: 'us_xpress'
            }
          ];
        default:
          console.log('Returning international rates');
          return [
            {
              service: 'International Tracked Package',
              rate: 45.00,
              estimated_days: '7-14',
              code: 'international_tracked'
            }
          ];
      }
    };

    const shippingRates = getRatesByCountry(country);
    console.log('Setting rates:', shippingRates);
    setRates(shippingRates);
    setLoading(false);
  }, [country]);

  if (loading) {
    return <div className="mt-4">Loading shipping rates...</div>;
  }

  if (!rates.length) {
    return <div className="mt-4">Please select a country to view shipping rates.</div>;
  }

  return (
    <div className="my-4">
      <h4 className="font-semibold mb-2">Available Shipping Options:</h4>
      <div className="space-y-2">
        {rates.map((rate) => (
          <label 
            key={rate.code} 
            className={`border p-3 rounded flex items-center cursor-pointer hover:border-blue-500 bg-white ${
              selectedRate?.code === rate.code ? 'border-blue-500 bg-blue-50' : ''
            }`}
          >
            <input
              type="radio"
              name="shippingRate"
              className="mr-3"
              checked={selectedRate?.code === rate.code}
              onChange={() => onShippingSelect(rate)}
            />
            <div className="flex-1 flex justify-between items-center">
              <div>
                <div className="font-medium">{rate.service}</div>
                <div className="text-sm text-gray-600">
                  Estimated delivery: {rate.estimated_days} days
                </div>
              </div>
              <div className="font-semibold">
                CA${rate.rate.toFixed(2)}
              </div>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ShippingRates;
